export const BugReport = {
  bug_list: '/v3/system/bug/category',
  store_bug: '/v3/system/bug'
}
